import React from "react";

import TableWrapper from "../../shared/bootstrap/TableWrapper.jsx";
import TableHeaderColumn from "../../shared/TableHeaderColumn.jsx";
import Contact from "./Contact.jsx";

/**
 * @typedef {import("../../../jsdoc/ExistingContract.js").ExistingContract} ExistingContract
 */

/**
 * Contacts component
 * @param {Object} props
 * @param {number} props.stnSeq
 * @param {ExistingContract[]} props.existingContacts
 * @returns {React.JSX.Element}
 */
export default function Contacts({ stnSeq, existingContacts }) {
  return (
    <div className="panel-body">
      <TableWrapper id="contactInfo" summary={`List of Contacts for STN: ${stnSeq}`} condensed={false}>
        <thead role="rowgroup">
          <tr role="row">
            <TableHeaderColumn id="name-head" text="Name" />
            <TableHeaderColumn id="email-head" text="E-mail Address" />
            <TableHeaderColumn id="phone-head" text="Phone Number" />
          </tr>
        </thead>
        <tbody role="rowgroup">
          {existingContacts.map((contact, index) => (
            <Contact key={contact.contactSeq} primary={index === 0} contact={contact} />
          ))}
        </tbody>
      </TableWrapper>
    </div>
  );
}
